export default "__VITE_ASSET__ClZpgKRa__"